var r={rtl:"frz7f",ltr:"AnCKd"};export{r as M};
//# sourceMappingURL=rtl.rtlignore-77ace20d.js.map
